import React from 'react';
import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Image,
  Img,
  Link,
  ListItem,
  OrderedList,
  Text,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const RiseInAiContextBlog = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
            >
              The Rise of AI in Private Equity and other Alternative Capital
              Strategies
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Flex
          flexDir={{ xs: 'column-reverse', md: 'row' }}
          px={{ xs: '8px', md: '0px' }}
          mt={{ xs: '32px', md: '80px' }}
        >
          <Flex
            w={{ xs: '100%', md: '27%' }}
            mt={{ xs: '32px', md: '0px' }}
            flexDir="column"
            rowGap="16px"
            mr={{ xs: '0px', md: '40px' }}
            ml={{ xs: '0px', sm: '10px' }}
            mb={{ xs: '16px', md: '8px' }}
          >
            <Heading
              fontSize="22px"
              lineHeight="22px"
              textAlign={{ xs: 'center', sm: 'left' }}
            >
              Follow the Authors
            </Heading>
            <Box
              w="100%"
              h="1.5px"
              bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
              my="8px"
            />
            {[
              {
                name: 'Prashant Garg',
                position: 'Partner, Technology Consulting, EY India',
                image:
                  'https://www.ivca.in/_next/image?url=https%3A%2F%2Fspace.levo.so%2FWGLBUT82%2FScreenshot2024-10-08at55540PM-ZnMjUQQaNJGK.png&w=2048&q=75',
              },
              {
                name: 'Santosh Tiwari',
                position: 'Partner, EY-Parthenon India',
                image:
                  'https://www.ivca.in/_next/image?url=https%3A%2F%2Fspace.levo.so%2FWGLBUT82%2FSantoshTiwari-OaJDLBBpnjve.jpg&w=3840&q=75',
              },
            ].map((item, index) => (
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Heading
                      variant="blogQuestion"
                      textAlign={{ xs: 'center', sm: 'left' }}
                    >
                      {item.name}
                    </Heading>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            ))}
          </Flex>

          <Box w={{ xs: '100%', md: '73%' }}>
            <Text variant="blogAnswer" mb="20px">
              The intersection of Artificial Intelligence (AI) and its use cases
              in Private Equity (PE) and other Alternative Capital strategies is
              rapidly reshaping the financial landscape. As private equity firms
              seek greater efficiency and smarter decision-making, AI is
              emerging as a pivotal enabler of value creation, improved
              operational performance, and superior investment outcomes. This
              transformation is not just technological—it is also strategic,
              driving the adoption of AI capabilities to achieve differentiated
              outcomes and returns in an increasingly competitive market.
            </Text>
            <Box my="16px">
              <Text variant="blogAnswer" fontWeight="800">
                AI Adoption by Private Equity and other Alternative Capital
                strategies: Where and How?
              </Text>

              <Text variant="blogAnswer" mb="20px">
                Alternative Capital management firms are steadily embracing AI
                as a key driver for value across their portfolios. AI is now
                central to the evolution of Alternative Capital managers, with
                firms actively integrating AI capabilities across investment
                stages—from deal sourcing to operational enhancements and
                portfolio management.
              </Text>
              <Text variant="blogAnswer" mb="20px">
                AI adoption in PE / Alternative Capital Managers can be seen in
                three core areas:
              </Text>
            </Box>
            <OrderedList>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Deal Sourcing and Origination:
                  </Text>{' '}
                  Leveraging AI to enhance deal origination has become an
                  essential practice. With $1.4 trillion of PE dry powder
                  waiting to be deployed, AI tools are being used to rapidly
                  identify opportunities that match specific criteria,
                  significantly enhancing the speed and accuracy of deal
                  sourcing.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Data-Driven Insights for Portfolio Management:
                  </Text>{' '}
                  AI is also transforming the approach to managing portfolio
                  companies. By analysing vast datasets, including historical
                  information from multiple business cycles, AI provides
                  data-driven insights that are key to supporting strategic
                  decisions. This capability is pivotal for both general
                  partners (GPs) and limited partners (LPs) looking to gain more
                  visibility and enhance collaboration.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Value Creation and Operational Efficiency:
                  </Text>{' '}
                  The integration of AI tools such as generative AI has enabled
                  GP firms to streamline key operational functions, reduce
                  costs, and improve productivity. EY’s work with GP clients
                  demonstrate how generative AI can help reimagine customer
                  support processes, resulting in notable productivity gains.
                </Text>
              </ListItem>
            </OrderedList>
          </Box>
        </Flex>
        <Box>
          <Box my="16px">
            <Text variant="blogAnswer" fontWeight="800">
              AI as a Disruptor in the Alternative Capital Landscape - What to
              get right?
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              AI is poised to be a disruptive force within the Alternative
              Capital landscape, transforming how funds are managed, raised, and
              invested. With technologies like predictive analytics, generative
              models, and machine learning, private equity firms can enhance the
              decision-making process at both the fund and portfolio level.
              However, while adopting AI and new technologies, following needs
              to be kept in mind:
            </Text>

            <OrderedList mt="22px">
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Effective AI Integration:
                  </Text>{' '}
                  Private equity and other GP firms need to focus on effectively
                  integrating AI across their entire portfolio to outperform
                  peers and ensure sustainable business models. This involves
                  scaling AI capabilities to transform portfolio companies and
                  leverage the latest technologies for better decision-making
                  and operational efficiency.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Identifying Meaningful Use Cases:
                  </Text>{' '}
                  Firms face challenges in identifying where and how to leverage
                  AI effectively. It is essential to distinguish between hype
                  and meaningful use cases to maximize the benefits of AI
                  integration. Investment in technology, including AI, should be
                  aligned with strategic priorities and tailored to address
                  specific business needs.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Risk Management:
                  </Text>{' '}
                  Risks associated with the use of generative AI, such as bad
                  data leading to incorrect answers, bias, errors, and potential
                  operational slowdowns, need to be addressed. Firms should
                  focus on building robust AI governance frameworks to mitigate
                  these risks and ensure that AI acts as a force multiplier
                  rather than a hindrance to business operations.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Future Investment Landscape:
                  </Text>{' '}
                  The convergence of AI, alternative capital, and private equity
                  is shaping the future investment landscape. Firms should
                  continue to explore and invest in innovative technologies like
                  RegTech, automated portfolio management systems, and
                  blockchain to drive operational efficiency, value creation,
                  and resilience in a technology-driven environment.
                </Text>
              </ListItem>
            </OrderedList>
          </Box>
          <Box mt="32px">
            <Text variant="blogAnswer" fontWeight="800">
              Technology Trends in Fund Management: Harnessing AI and Beyond
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The rise of advanced technologies is reshaping the future of fund
              management, enabling greater efficiency, transparency, and
              informed decision-making across the investment lifecycle. Key
              technology trends include:
            </Text>

            <OrderedList mt="22px">
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Regulatory Technology (RegTech):
                  </Text>{' '}
                  Automated KYC (Know Your Customer) and AML (Anti-Money
                  Laundering) systems reduce the manual burden of compliance,
                  enabling managers to focus on the strategic aspects of
                  investing while maintaining adherence to SEBI regulations.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Automated Portfolio Management Systems:
                  </Text>{' '}
                  These systems provide real- time visibility into portfolio
                  performance—especially useful for complex portfolios under
                  Category III AIFs—thereby improving transparency and risk
                  management.
                </Text>
              </ListItem>
              <ListItem mb="4px">
                <Text variant="blogAnswer" pl={{ md: '12px' }}>
                  <Text as="span" fontWeight="700">
                    Blockchain for Trust and Transparency:
                  </Text>{' '}
                  Blockchain-based ledgers ensure an immutable and transparent
                  record of transactions, bolstering compliance and audit
                  capabilities while enhancing investor trust. Private equity
                  firms are already successfully deploying AI across portfolios.
                  EY has also assisted clients in implementing AI Centers of
                  Excellence within their portfolios, encouraging collaboration,
                  cross-pollination of ideas, and AI-driven value creation. AI
                  strategies, including generative AI for customer support and
                  predictive analytics for strategic insights, have demonstrated
                  tangible benefits, driving cost reduction and improving
                  productivity.
                </Text>
              </ListItem>
            </OrderedList>
          </Box>
          <Box mt="32px">
            <Text variant="blogAnswer" fontWeight="800">
              The Impact of AI on Value Creation and Sustainability
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The impact of AI across the PE and Alternative Capital industry is
              unmistakable. AI tools allow for better decision-making through
              deep analytics, process automation, and real-time insights. As a
              result, Alternative Capital Management firms are witnessing
              significant improvements in operational efficiency and enhanced
              value creation.
              <br /> While early AI-driven wins are encouraging, scaling AI
              across the entire portfolio is crucial for sustainable success.
              Firms that can replicate AI successes at scale will be the ones to
              outperform competitors, raise larger funds, and create sustainable
              business models. This underscores the need for an organized and
              strategic approach to AI adoption—using detailed playbooks,
              starting with pilots, and rolling out effective solutions across
              all portfolio companies.
            </Text>
          </Box>
          <Box mt="32px">
            <Text variant="blogAnswer" fontWeight="800">
              Generative AI:
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              Generative AI is helping GP firms build on the data analytics
              capabilities they have been homing in recent years. Unlike
              traditional AI models focused on structured data, generative AI
              can handle unstructured data at scale, delivering seamless
              insights that support decision-making. This enables PE and other
              GP firms to make the most of unstructured information, like data
              in documents or emails, and extract meaningful, actionable
              intelligence that enhances portfolio management and growth
              strategies.
            </Text>
          </Box>
          <Box mt="32px">
            <Text variant="blogAnswer" fontWeight="800">
              Conclusion: AI and Alternative Capital: Shaping the Future
            </Text>
          </Box>
          <Box my="16px">
            <Text variant="blogAnswer">
              The convergence of AI and Alternative Capital is transforming the
              investment landscape, optimizing decision-making, operations, and
              value creation. The future of PE and other Alternative Capital
              Strategies depends on scaling AI across portfolios. Firms that
              effectively leverage AI will achieve greater returns, operational
              efficiency, and resilience, emerging as leaders in a transformed,
              technology-driven investment world.
            </Text>
          </Box>

          <Box my="16px">
            <Text variant="blogAnswer">
              For more information and to register, visit
              <Link
                href="https://www.ivca.in/altcap-101"
                target="_blank"
                fontWeight="700"
                ml="4px"
                style={{ color: 'blue', textDecoration: 'underline' }}
              >
                https://www.ivca.in/altcap-101
              </Link>
            </Text>
          </Box>
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default RiseInAiContextBlog;
